import React, { useState } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import PunchCardLogo from "../../components/logos/PunchCardLogo";
import AdminSignIn from "../components/SignIn";
import AnimatedBackground from "../../components/AnimatedBackground";
import Container from "../../components/Container";

interface AdminLoginPageProps {
  onSuccess?: () => void;
}

const AdminLoginPage: React.FunctionComponent<AdminLoginPageProps> = ({ onSuccess }) => {
  const [error, setError] = useState<string | null>(null);

  const handleError = (errorMessage: string) => {
    setError(errorMessage);
  };

  const handleSuccess = () => {
    setError(null);
    if (onSuccess) {
      onSuccess();
    } else {
      window.location.href = "/admin/workspaces";
    }
  };

  return (
    <AnimatedBackground>
      <Container>
        <div className="w-full max-w-md">
          <Card className="shadow-xl bg-card/95 backdrop-blur-sm">
            <CardHeader className="items-center">
              <PunchCardLogo type="icon" />
            </CardHeader>
            <CardContent>
              {error && (
                <div className="bg-destructive/10 border border-destructive/40 px-4 py-3 rounded mb-4">
                  <Text variant="sm" className="text-destructive">{error}</Text>
                </div>
              )}

              <Heading level={1} variant="sm" className="mb-6">Admin Sign In</Heading>

              <AdminSignIn onSuccess={handleSuccess} onError={handleError} />
            </CardContent>
          </Card>
        </div>
      </Container>
    </AnimatedBackground>
  );
};

export default AdminLoginPage;
